import { render, staticRenderFns } from "./FieldsetContractCompanyData.yaml?vue&type=template&id=bbca6fce&component"
import script from "./FieldsetContractCompanyData.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetContractCompanyData.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports